// nb.util.tz
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { TimeZoneStrings, getTimeZoneId } from 'enums/TimeZone'

dayjs.extend(utc)
dayjs.extend(timezone)

export function getOffset(date: Date | number, timeZone?: TimeZoneStrings): number {
  const timeZoneId = getTimeZoneId(timeZone)
  return -dayjs(date).tz(timeZoneId).utcOffset()
}

// /**
//  * Convert a UTC time to a time with specific timezone
//  * @param {Date | number} time
//  * @return {number}
//  */
export function addTz(time: Date | number, timeZone: TimeZoneStrings): number {
  const timeInMs = time instanceof Date ? time.getTime() : time
  const offset = getOffset(new Date(timeInMs), timeZone)
  return timeInMs - offset * 60 * 1000
}

export function subTz(time: Date | number, timeZone: string): number {
  const timeInMs = time instanceof Date ? time.getTime() : time
  const timeZoneId = getTimeZoneId(timeZone)
  const localTime = dayjs.utc(timeInMs).tz(timeZoneId, true)
  const correctedTimeInMs = localTime.utc().valueOf()
  return correctedTimeInMs
}

// /**
//  *
//  * @param {Date} date
//  * @param {TimeZone} timeZone
//  * @returns
//  */
// export function switchTimeZone(date, timeZone = TimeZone.getActiveId()) {
//   return moment.tz(date, timeZone).format('YYYY-MM-DD HH:mm')
// }

const format = (pattern: string, time: Date | number | string, timeZone: TimeZoneStrings) => {
  const timeZoneId = getTimeZoneId(timeZone)

  return dayjs(time).tz(timeZoneId).format(pattern)
}

export const getShortDateDisplay = (time: Date | number, timeZone: TimeZoneStrings) => {
  const pattern = 'MMM D'
  return format(pattern, time, timeZone)
}

export const getYearDateDisplay = (time: Date | number, timeZone: TimeZoneStrings) => {
  const pattern = 'MMM D, YYYY'
  return format(pattern, time, timeZone)
}

export const getYearDateHourMinuteDisplay = (time: Date | number, timeZone: TimeZoneStrings) => {
  const pattern = 'MMM D, YYYY h:mm A'
  return format(pattern, time, timeZone)
}

export const getYearDateDisplayNumeric = (time: Date | number, timeZone: TimeZoneStrings) => {
  const pattern = 'M/D/YY'
  return format(pattern, time, timeZone)
}

export const getYearDateHourMinuteDisplayNumeric = (
  time: Date | number,
  timeZone: TimeZoneStrings
) => {
  const pattern = 'M/D/YY h:mm A'
  return format(pattern, time, timeZone)
}

export const getFullDisplay = (time: string | number, timeZone: TimeZoneStrings) => {
  const timeInMs = Number(time)
  const timeDisplay = format('dddd, MMMM D, YYYY h:mm:ss A', timeInMs, timeZone)
  const timeZoneOffset = -getOffset(timeInMs, timeZone) / 60
  const sign = timeZoneOffset >= 0 ? '+' : ''
  return `${timeDisplay} UTC${sign}${timeZoneOffset}`
}

export const getTime = (date: Date, tz?: TimeZoneStrings) => {
  const timezoneId = getTimeZoneId(tz)

  const time = dayjs(date.getTime())
  return time.tz(timezoneId)
}

export const getOffsetGmtString = (date: Date, tz?: TimeZoneStrings) =>
  getTime(date, tz).format('[GMT]Z')

export const getGMTString = (tz?: TimeZoneStrings) => {
  const rv = getOffsetGmtString(new Date(), tz)
  return `(${rv})`
}

export const get24TimeDisplay = (time?: number) => (time ? `${time}:00` : '')
